import React from "react";
// import ReactDOM from "react-dom/client";
import ReactDOM from "react-dom";
import { init } from "@umengfe/apm";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import "amfe-flexible";
import "./index.scss";
import "./i18n";
import { UMENG_IGNORE_ERRORS } from "logic/src/constants";
import "logic/src/styles/index.scss";

// @ts-ignore
if (typeof Promise.withResolvers === "undefined") {
  // @ts-ignore
  Promise.withResolvers = function () {
    let resolve, reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

// @ts-ignore
if (!isIE()) {
  // 友盟性能监控
  // @ts-ignore
  init({
    pageFilter: { mode: "ignore", rules: [] },
    pid: UMENG_PERFORMANCE_APP_KEY,
    logLevel: 0, // 0 表示ERROR日志, 1 表示WARN日志, 2 表示INFO日志, 3 表示DEBUG日志
    errorFilter: {
      mode: "ignore",
      rules: [
        (args: any) => {
          return args.log && UMENG_IGNORE_ERRORS.includes(args.log.msg)
            ? true
            : false;
        },
      ],
    },
  });

  // const root = ReactDOM.createRoot(
  //   document.getElementById("root") as HTMLElement,
  // );
  // root.render(<App />);
  ReactDOM.render(<App />, document.getElementById("root"));
  reportWebVitals();
}
